import React from 'react'

function Wallet() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
        >
            <path
                fill="currentColor"
                d="M19.62 18.5a3.75 3.75 0 010-7.5h2.26a.25.25 0 00.24-.25v-2.5a2.5 2.5 0 00-2.5-2.5h-17a2.51 2.51 0 00-2.5 2.5v13a2.51 2.51 0 002.5 2.5h17a2.5 2.5 0 002.5-2.5v-2.5a.25.25 0 00-.24-.25z"
                transform="scale(.83333)"
            ></path>
            <path
                fill="currentColor"
                d="M22.62 12.5h-3a2.25 2.25 0 000 4.5h3a1.51 1.51 0 001.26-1.5V14a1.51 1.51 0 00-1.26-1.5zM19.81 1.18a1.21 1.21 0 00-.56-.76 1.24 1.24 0 00-.94-.13L5.44 3.76a.24.24 0 00-.18.24.25.25 0 00.24.22h14.77a.24.24 0 00.19-.1.23.23 0 00.05-.12z"
                transform="scale(.83333)"
            ></path>
        </svg>
    )
}

export default Wallet
